import { Route } from 'vue-router';
import { vxm } from '@/stores';

export default (to: Route, from: Route, next: any): void => {
  vxm.navigation.setLoading(true);
  next();
};